<template>
  <es-overlay show="{{visible}}" position="fade"/>
  <es-popup
    wx:model="{{visible}}"
    overlay="{{false}}"
    position="bottom"
    closeable
    bind:close="closePopup"
  >
    <view class="main">
      <image class="title-bac" mode="aspectFit" src="https://img-hxy021.didistatic.com/static/starimg/img/d8LYVTcyVg1689839655760.png"></image>
      <view class="title">提前支付，无需等待</view>
      <view class="tips">
        <view class="tip" wx:for="{{formatTips}}" wx:key="index" wx:for-item="tip">
          <view class="icon"></view>
          <view><text 
            wx:for="{{tip}}"
            wx:class="{{ {highlight:item.highlight} }}"
          >{{item.value}}</text></view>
        </view>
      </view>
      <view class="footer">
        <es-button bind:click="onAction('wait')" custom-class="prepay-btn">再等一会</es-button>
        <es-button bind:click="onAction('pay')" custom-class="prepay-btn active">立即支付</es-button>
      </view>
    </view>
  </es-popup>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { filterHighlightText } from '@/common/public'

  createComponent({
    props: {
      value: false,
    },
    computed: {
      visible: {
        get() {
          return this.value
        },
        set() {}
      },
      formatTips() {
        const texts = [
          '由于当前购票人数较多，占座时间较长，为了不影响您的购票体验，可以先{{预付火车票费用}}，占座成功后会立即为您出票，出票后会有短信通知。',
          '若占座失败，会短信通知并立即为您原路退还全部费用。提前祝您旅途愉快！',
        ]
        return texts.map(str => filterHighlightText(str))
      },
    },
    methods: {
      closePopup() {
        this.triggerEvent('onAction', { type: 'close' })
      },
      onAction(type) {
        this.triggerEvent('onAction', { type })
      },
    },
  })
</script>

<style lang="stylus" scoped>
.main
  padding-bottom 84px
  border-radius 12px 12px 0 0
  overflow hidden
  background linear-gradient(180deg, #D9EBFF 0%, #FFFFFF 26%), #FFFFFF
  text-align center
  .title-bac
    width 80px
    height 48px
    margin 25px 10px 0 0
  .title
    font-size 18px
    color #000000
  .tips
    padding 12px
    border-radius 8px
    background linear-gradient(90deg, #E6F1FF 0%, rgba(244,249,255,0.41) 100%)
    margin 15px 16px 32px
    color #333
    font-size 12px
    line-height 24px
    text-align left 
    .tip
      display flex
      align-items flex-start
      .icon
        background-image url('https://img-hxy021.didistatic.com/static/starimg/img/tI9Ya6b8Q21689839356871.png')
        background-position center
        background-repeat no-repeat
        background-size contain
        width 12px
        height 12px
        margin 6px 8px 0 0
        flex none
      .highlight
        color #1473FF
  .footer
    height 84px
    width 100%
    position fixed
    bottom 0
    padding 16px 21px 0
    box-sizing border-box
    box-shadow 0px -2px 10px 0px rgba(0, 0, 0, 0.04)
    background-color #fff
    display flex
    align-items flex-start
    justify-content space-between
    .prepay-btn
      border-radius 8px
      background-color #F0F0F0
      color #333
      font-size 16px
      border none
      &.active
        color #fff
        background-color #FF7F41
    .es-button + .es-button
      margin-left 12px
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-popup': '@didi/es-mpx-ui/lib/popup',
      'es-overlay': '@didi/es-mpx-ui/lib/overlay',
    }
  }
</script>